import { apiClient } from "../../../api/client";
import * as ActionType from "./order.type";

const normalizeError = (error) => ({
  message: error?.message || "Request failed",
  code: error?.code || "UNKNOWN",
  details: error?.details || {},
});

export const getOrder = () => async (dispatch) => {
  dispatch({ type: ActionType.GET_ORDER_REQUEST });
  const res = await apiClient.get("order/getOrders");
  if (res.ok) {
    dispatch({ type: ActionType.GET_ORDER_SUCCESS });
    dispatch({ type: ActionType.GET_ORDER, payload: res.data?.orders });
  } else {
    dispatch({
      type: ActionType.GET_ORDER_FAILURE,
      payload: normalizeError(res),
    });
    console.error(res.message);
  }
};

export const getOrderDetail = (id) => async (dispatch) => {
  dispatch({ type: ActionType.GET_ORDER_DETAIL_REQUEST });
  const res = await apiClient.get(`order/orderDetail?orderId=${id}`);
  if (res.ok) {
    dispatch({ type: ActionType.GET_ORDER_DETAIL_SUCCESS });
    dispatch({ type: ActionType.GET_ORDER_DETAIL, payload: res.data?.order });
  } else {
    dispatch({
      type: ActionType.GET_ORDER_DETAIL_FAILURE,
      payload: normalizeError(res),
    });
    console.error(res.message);
  }
};

export const updateOrder =
  (userId, orderId, status, itemId, data = {}) =>
  async (dispatch) => {
    const res = await apiClient.patch("order/updateOrder", {
      userId,
      orderId,
      status,
      itemId,
      ...data,
    });
    if (res.ok && res.data?.status) {
      dispatch({
        type: ActionType.UPDATE_ORDER,
        payload: { updateOrder: res.data?.order || res.data?.updateOrder || res.data },
      });
    } else {
      console.error(res.message);
    }
  };
